export default __webpack_public_path__ + "static/minute-media-128173739bfe4f9118a6b6d484dd520e.svg";